import Reveal from "@/components/Reveal";
import { TrendingDown, Gauge, ShieldCheck, Repeat } from "lucide-react";

const items = [
  { icon: TrendingDown, label: "Fewer resubmissions", desc: "Catch issues before handover, not after." },
  { icon: Gauge, label: "Higher data quality", desc: "Consistent, schema-accurate ADAC output." },
  { icon: ShieldCheck, label: "Standardized QA", desc: "One review standard across every submission." },
  { icon: Repeat, label: "Faster turnaround", desc: "Automate the repetitive validation grind." },
];

export default function ValueStrip() {
  return (
    <section data-testid="value-strip-section" className="border-y border-zinc-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
          {items.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.07} className="flex items-start gap-4">
              <span className="shrink-0 h-10 w-10 grid place-items-center bg-[#E6EBF5] text-[#0033A0] rounded-sm">
                <it.icon size={20} strokeWidth={1.6} />
              </span>
              <div>
                <p className="font-heading font-medium text-zinc-900">{it.label}</p>
                <p className="mt-1 text-sm text-zinc-500 leading-relaxed">{it.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
